<template>
  <div class="more">
    <h2 class="more__title">
      {{ title }}
    </h2>

    <ul class="more__list">
      <li
        v-for="product in moreProducts"
        :key="product.id"
        class="more__list-item"
      >
        <div
          class="product"
          :class="{ 'product--disabled': product.available && product.available !== true }"
        >
          <div>
            <div
              class="product__pic product__pic--revers"
              :class="product.fileR"
            />

            <p
              class="product__title"
              v-html="product.title"
            />

            <div
              class="product__over"
            >
              <ButtonDefault
                v-if="(!product.available || product.available === true)"
                :theme="theme"
                arrow="top-right"
                :to="['./', product.path] | joinPath"
                :pointer-absolute="true"
                :negative="true"
                :border="true"
              />
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ButtonDefault from '@/components/buttons/ButtonDefault.vue';

export default {
  components: { ButtonDefault },

  props: {
    title: { type: String, default: null },
    ignoreId: { type: String, default: null },
    theme: { type: String, default: null },
    products: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    moreProducts() {
      const { products, ignoreId } = this.$props;
      return products.filter(p => p.id !== ignoreId && (typeof p.available === 'undefined' || p.available === true));
    },
  },
};
</script>

<style lang="stylus" scoped>
.more {
  color: $cl-white;
}

.more__title {
  @extend $typo-product-more-title;
  text-transform: uppercase;
  margin-bottom: 30px;
  max-width: 99%;

  +desktop() {
    margin-bottom: 40px;
  }
}

.more__list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: auto;
  hide-scrollbar();

  padding 0 25px;

  +desktop() {
    padding 0 35px;
  }

  +product-splitscreen() {
    padding 0;
    flex-wrap: wrap;
  }
}

.more__list-item {
  +product-splitscreen() {
    width: 50%;
  }
}

.product {
  position: relative;
  padding: 0 25px;
  min-width: 220px;

  +product-splitscreen() {
    padding: 0 13px;
    min-width: 97px;
  }

  +above('xl') {
    min-width: 194px;
  }

  +above('xxl') {
    padding: 0 35px;
  }

  &--disabled {
    display: none;
    opacity: 0.2;
  }
}

.product__title {
  @extend $typo-product-more-name;
  margin: 10px 0 0 0;

  +product-splitscreen() {
    margin: 10px 0 30px 0;
  }
}

.product__pic {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-size: 100%;
}

.product__over {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-left: 70%;
  padding-top: 45%;

  opacity: 0;

  +above('xl') {
    opacity: 1;
  }
}
</style>
